// eslint-disable-next-line boundaries/external
import { AbstractControl } from '@angular/forms';

export function unicodeTextValidator(control: AbstractControl): { unicodeText: boolean } | null {
  const value = control.value?.trim();

  // Check if contains at least one Unicode letter or number
  const hasLetterOrNumber = /[\p{L}\p{N}]/u.test(value);

  if (!value) {
    return null;
  }

  if (!hasLetterOrNumber) {
    return { unicodeText: true };
  }

  return null;
}
